export default __webpack_public_path__ + "static/media/sonic.9c98df7d.png";